export default __webpack_public_path__ + "static/media/basement.237f4f8e.jpg";